
import Carousel from "../components/carousel";
import Currency from '../tools/currency';
import ProductItemColorSwatch from "../components/product-item-color-swatch"

export default class RecentlyViewedProductsSection{
    constructor(container) {
        this.element = container;
        this.options = JSON.parse(this.element.getAttribute('data-section-settings'));
        if (this.options['productId']) {
            this._saveProduct(this.options['productId']);
          }
        
          // Setup product item color swatchs
        //new ProductItemColorSwatch(this.element);          
        this._fetchProducts();
    }
    onUnload() {
        if (this.carousel) {
            this.carousel.destroy();
        }
    } 
    _saveProduct(productId) {
        var items = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');

        // We check if the current product already exists, and if it does not, we add it at the start
        if (!items.includes(productId)) {
          items.unshift(productId);
        }

        // Then, we save the current product into the local storage, by keeping only the 8 most recent
        try {
          localStorage.setItem('recentlyViewedProducts', JSON.stringify(items.slice(0, 8)));
        } catch (error) {
          // Do nothing, this may happen in Safari in incognito mode
        }
    }
    _fetchProducts() {
        var _this55 = this;

        var queryString = this._getSearchQueryString();
        
        if (queryString === '') {
          return;
        }

        // If we have a non empty query string we do a search query
        fetch('/search?view=recently-viewed-products&type=product&q=' + queryString, {
          credentials: 'same-origin',
          method: 'GET'
        }).then(function (response) {
          response.text().then(function (content) {
            var tempElement = document.createElement('div');
            tempElement.innerHTML = content;

            // Set the content
            _this55.element.innerHTML = tempElement.querySelector('.section').innerHTML;

            // Show the section
            _this55.element.parentNode.style.display = 'block';

            // Convert any amount (if applicable)
            if (window.theme.currencyConversionEnabled) {
              //__WEBPACK_IMPORTED_MODULE_2__helper_Currency__["default"].convertAll(_this55.element);
            }

            // And finally let's create the carousel !
            _this55.carousel = new Carousel(_this55.element.querySelector('[data-flickity-config]'));
          });
        });
    }
    _getSearchQueryString() {
        var items = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');

        // If we are on a product template, we make sure to remove the main product from the related product
        if (items.includes(this.options['productId'])) {
          items.splice(items.indexOf(this.options['productId']), 1);
        }

        return items.map(function (item) {
          return 'id:' + item;
        }).join(' OR ');
    }

}